'use es6';

import _ from 'underscore';
import { fromJS, Map } from 'immutable';
import GoodImageTypes from 'marketplace-lib/constants/GoodImageTypes';
import ModuleImageTypes from 'marketplace-lib/constants/ModuleImageTypes';
import ActionTypes from '../constants/ActionTypes';
import GoodTagTypes from '../constants/GoodTagTypes';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import { getEnglishTextFieldFromGoodTextObj } from '../utils/utils';
var initialState = fromJS({
  requestStatus: RequestStatusTypes.UNINITIALIZED,
  averageRating: 0,
  certifications: [],
  children: [],
  codingType: [],
  contactEmail: '',
  customModuleCompatibilityTag: [],
  customModulePurposeTag: [],
  customModuleImages: [],
  customerPurchaseInfo: {},
  description: '',
  downloads: '',
  goodId: '',
  documentationLink: '',
  exampleLink: '',
  imageUrl: '',
  smallImageUrl: '',
  family: '',
  featureTags: [],
  hasReviewed: false,
  industryTag: [],
  templatePurposeTag: [],
  isFree: false,
  layoutTag: [],
  newVersionAvailable: false,
  packCounts: [],
  parents: [],
  price: null,
  providerName: '',
  providerPortalId: null,
  providerWebsite: '',
  purchaseError: '',
  purchaseInProcess: false,
  reviews: [],
  showSitePagePql: false,
  stripeProvider: true,
  subType: '',
  type: '',
  totalChildren: 0,
  transactionId: null,
  goodName: '',
  urlToken: '',
  assetNamesBySubType: {}
});

function getImgUrl(goodInfo, goodImageType) {
  if (goodInfo.goodImages) {
    return goodInfo.goodImages[goodImageType];
  }

  return '';
}

function getCustomModuleImages(goodInfo) {
  return ModuleImageTypes.reduce(function (images, imageType) {
    var image = getImgUrl(goodInfo, imageType);

    if (image) {
      images.push(image);
    }

    return images;
  }, []);
}

function getLocalizedTextField(field, goodInfo) {
  if (goodInfo.goodText) {
    return getEnglishTextFieldFromGoodTextObj(field, goodInfo.goodText);
  }

  return '';
}

function parseTag(payload, tag) {
  if (_.isObject(payload.goodInfo.goodTags) && _.isArray(payload.goodInfo.goodTags[tag])) {
    return payload.goodInfo.goodTags[tag];
  }

  return null;
}

export default function goodDetailsReducer() {
  var goodDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.GOOD_DETAILS_REQUESTED:
      if (action.error) {
        return goodDetails.set('requestStatus', RequestStatusTypes.FAILED);
      }

      return goodDetails.set('requestStatus', RequestStatusTypes.PENDING);

    case ActionTypes.GOOD_DETAILS_RECEIVED:
      return goodDetails.merge({
        requestStatus: RequestStatusTypes.SUCCEEDED,
        averageRating: action.payload.reviewInfo ? action.payload.reviewInfo.rating : 0,
        certifications: action.payload.providerInfo.awards || [],
        children: action.payload.children,
        codingType: parseTag(action.payload, GoodTagTypes.COS_TEMPLATE_CODING_TYPE) || [],
        contactEmail: action.payload.providerInfo.supportEmail || action.payload.providerInfo.contactEmail,
        customModuleCompatibilityTag: parseTag(action.payload, GoodTagTypes.MODULE_COMPATIBILITY) || [],
        customModulePurposeTag: parseTag(action.payload, GoodTagTypes.MODULE_PURPOSE) || [],
        customModuleImages: getCustomModuleImages(action.payload.goodInfo),
        customerPurchaseInfo: action.payload.customerPurchaseInfo || {},
        description: getLocalizedTextField('DESCRIPTION', action.payload.goodInfo),
        downloads: action.payload.downloadCount,
        documentationLink: action.payload.goodInfo.documentationLink,
        exampleLink: action.payload.goodInfo.exampleLink,
        featureTags: parseTag(action.payload, GoodTagTypes.COS_TEMPLATE_FEATURES) || [],
        goodId: action.payload.goodInfo.goodId,
        hasReviewed: action.payload.customerPurchaseInfo ? action.payload.customerPurchaseInfo.reviewed : false,
        imageUrl: getImgUrl(action.payload.goodInfo, GoodImageTypes.SCREENSHOT),
        smallImageUrl: getImgUrl(action.payload.goodInfo, GoodImageTypes.MARKETING_IMAGE_SMALL),
        industryTag: parseTag(action.payload, GoodTagTypes.INDUSTRY) || [],
        templatePurposeTag: parseTag(action.payload, GoodTagTypes.COS_TEMPLATE_INTENT) || [],
        isFree: action.payload.goodInfo.free,
        layoutTag: parseTag(action.payload, GoodTagTypes.COS_TEMPLATE_LAYOUT) || [],
        newVersionAvailable: action.payload.newVersionAvailable || false,
        packCounts: action.payload.packCounts || [],
        parents: action.payload.parents || [],
        price: action.payload.goodInfo.price,
        providerName: action.payload.providerInfo.company,
        providerPortalId: action.payload.providerInfo.portalId,
        providerWebsite: action.payload.providerInfo.website,
        purchaseInProcess: false,
        reviews: action.payload.reviewInfo ? action.payload.reviewInfo.reviews : [],
        showSitePagePql: action.payload.pqlInfo ? action.payload.pqlInfo.showSitePageAddOn : false,
        stripeProvider: action.payload.providerInfo.stripeProvider,
        subType: action.payload.goodInfo.subType,
        type: action.payload.goodInfo.type,
        totalChildren: action.payload.totalChildren || 0,
        transactionId: action.payload.customerPurchaseInfo ? action.payload.customerPurchaseInfo.transactionId : null,
        goodName: getLocalizedTextField('NAME', action.payload.goodInfo),
        urlToken: action.payload.goodInfo.urlToken,
        assetNamesBySubType: action.payload.assetNamesBySubType || {}
      });

    case ActionTypes.PURCHASED_WITH_STRIPE:
      if (action.error) {
        return goodDetails.set('purchaseError', action.payload.message);
      }

      return goodDetails.set('purchaseInProcess', true);

    case ActionTypes.STRIPE_PURCHASE_COMPLETED:
      return goodDetails.set('purchaseInProcess', false);

    case ActionTypes.PURCHASED_WITH_PAYPAL:
      if (action.error) {
        return goodDetails.set('purchaseError', action.payload.message);
      }

      return goodDetails.set('purchaseInProcess', true);

    case ActionTypes.DISMISSED_PURCHASE_ERROR:
      return goodDetails.merge({
        purchaseError: '',
        purchaseInProcess: false
      });

    case ActionTypes.REVIEW_SUBMITTED_FROM_DETAILS_SUCCESS:
      return goodDetails.merge({
        hasReviewed: true,
        reviews: goodDetails.get('reviews').push(Map(action.payload.review))
      });

    case ActionTypes.REDELIVERING_GOOD:
      return goodDetails.merge({
        newVersionAvailable: false
      });

    case ActionTypes.GOOD_DETAILS_RESET:
      return initialState;

    default:
      return goodDetails;
  }
}